import { Phone, LogIn } from "lucide-react";
import { clinicConfig } from "@/config/clinic";

export const MobileCTABar = () => {
  return (
    <div
      data-testid="mobile-cta-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 backdrop-blur-md md:hidden"
    >
      <div className="grid grid-cols-2 gap-3 px-4 py-3">
        <a
          href={`tel:${clinicConfig.phoneTel}`}
          data-testid="mobile-call-cta"
          className="inline-flex items-center justify-center gap-2 rounded-full border border-border py-3 text-sm font-semibold text-foreground"
        >
          <Phone className="h-4 w-4" strokeWidth={1.5} /> Call
        </a>
        <a
          href={clinicConfig.patientPortalUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-signin-cta"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-primary py-3 text-sm font-semibold text-primary-foreground"
        >
          <LogIn className="h-4 w-4" strokeWidth={1.5} /> Patient Sign In
        </a>
      </div>
    </div>
  );
};

export default MobileCTABar;
